<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.fulfillment') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.salesFulfillment') }}</label>
          <div class="value">{{ detail.totalOrder || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.canceledOrders') }}</label>
          <div class="value">{{ detail.totalCancelProportion || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.serviceScore') }}</label>
          <div class="value">{{ detail.serviceIndex || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.mistakeAndDamagedOrders') }}</label>
          <div class="value">{{ detail.totalErrorOrMissOrFlawProportion || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.delayOrders') }}</label>
          <div class="value">{{ detail.totalDelayProportion }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.respondSpeedForFulfillmentIssues') }}</label>
          <div class="value">{{ detail.issuesRespond || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.avgServiceScoreArea') }}</label>
          <div class="value">{{ detail.avgServiceIndex }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.serviceScoreRankingArea') }}</label>
          <div class="value">{{ detail.serviceIndexRanking || '-' }}</div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.afterSaleSituation') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.afterSaleAging') }}</label>
          <div class="value">
            <span v-if="detail2.afterSaleExpire || detail2.afterSaleExpire == 0">{{ detail2.afterSaleExpire }}{{ $t('common.day') }}</span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.notAcceptedAfterSalesType') }}</label>
          <div class="value">{{ detail2.rejectSaleAfterType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.returnTimeLimit') }}</label>
          <div class="value">
            <span v-if="detail2.returnExpire || detail2.returnExpire == 0">{{ detail2.returnExpire }}{{ $t('common.day') }}</span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.notAcceptedAfterSalesCases') }}</label>
          <div class="value">{{ detail2.rejectDefect || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.whetherToAcceptAfterSales') }}</label>
          <div class="value">{{ detail2.acceptSaleAfter || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.notAcceptedAfterSalesCategories') }}</label>
          <div class="value">{{ detail2.rejectSaleAfterCategory || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.portalVersion') }}</label>
          <div class="value">{{ detail2.portalVersionType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.logisticsMode') }}</label>
          <div class="value">{{ detail2.logisticsType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.productConnectivityMethod') }}</label>
          <div class="value">{{ detail2.productSourceType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.stockErrorProblem') }}</label>
          <div class="value">{{ detail2.stockException || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.orderOperationMode') }}</label>
          <div class="value">{{ detail2.orderOperationType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.priceErrorProblem') }}</label>
          <div class="value">{{ detail2.priceException || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.packingBoxMode') }}</label>
          <div class="value">{{ detail2.orderPackType || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.performanceBottleneck') }}</label>
          <div class="value">{{ detail2.performanceBottleneck || '-' }}</div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.serviceScoreTrendGraph') }}</h2>
      <div class="chart-toolbar">
        <el-button type="text" @click="setMonthrange(0)">{{ $t('crm.last3Years') }}</el-button>
        <el-button type="text" @click="setMonthrange(1)">{{ $t('crm.thisYear') }}</el-button>
        <el-button type="text" @click="setMonthrange(2)">{{ $t('crm.lastYear') }}</el-button>
        <el-date-picker
          class="ml20"
          @change="changeMonth"
          v-model="monthrange"
          type="monthrange"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']"
          :start-placeholder="$t('common.startMonth')"
          :end-placeholder="$t('common.endMonth')">
        </el-date-picker>
      </div>
      <div class="chart" ref="chart"></div>
    </el-card>
  </div>
</template>

<script>
import {
  format,
  eachMonthOfInterval,
  startOfMonth,
  endOfMonth,
  addMonths,
  addYears,
  endOfYear,
  startOfYear,
} from 'date-fns';
import * as echarts from "echarts";
import {
  getPerformanceByVendorId,
  getPerformanceMonthByVendorId,
  getAfterSalePerformance,
} from '../api';

export default {
  data() {
    return {
      detail: {},
      detail2: {},
      monthrange: [],
    };
  },
  mounted() {
    window.addEventListener('resize', this.pageResize);
    getPerformanceByVendorId({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = res.data.data;
      }
    });
    getAfterSalePerformance({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail2 = res.data.data;
      }
    });
    const nowDate = new Date();
    this.monthrange = [startOfMonth(addMonths(nowDate, -12)).getTime(), endOfMonth(nowDate).getTime()];
    this.getChartData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pageResize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    getChartData() {
      if (!this.chart) {
        this.chart = echarts.init(this.$refs.chart);
      }
      getPerformanceMonthByVendorId({
        vendorId: this.$route.params.id,
        startTime: this.monthrange[0] ? this.monthrange[0] : null,
        endTime: this.monthrange[1] ? this.monthrange[1] : null,
      }).then(res => {
        if (res.data && res.data.success) {
          const data = this.monthFill(res.data.data || [], this.monthrange[0], this.monthrange[1]);
          const xAxis = data.map(item => item.yearTime);
          const yAxis = data.map(item => item.serviceIndex);
          this.chart.setOption({
            tooltip: {
              trigger: "axis",
              formatter: '{b0}<br /> {c0}%'
            },
            xAxis: {
              type: 'category',
              data: xAxis,
              name: '日期'
            },
            yAxis: {
              type: 'value',
              name: "%",
              name: '服务指数%',
              // min: 0,
              // max: 100,
            },
            series: [
              {
                data: yAxis,
                type: 'line',
                smooth: true,
                areaStyle: {
                  opacity: 0.3
                },
              }
            ]
          });
        }
      })
    },
    setMonthrange(type) {
      const nowDate = new Date();
      if (type === 0) {
        this.monthrange = [startOfMonth(addMonths(nowDate, -12 * 3)).getTime(), endOfMonth(nowDate).getTime()];
      } else if (type === 1) {
        this.monthrange = [startOfYear(nowDate).getTime(), endOfYear(nowDate).getTime()];
      } else if (type === 2) {
        this.monthrange = [startOfYear(addYears(nowDate, -1)).getTime(), endOfYear(addYears(nowDate, -1)).getTime()];
      }
      this.getChartData();
    },
    changeMonth() {
      this.monthrange = [startOfMonth(new Date(this.monthrange[0])).getTime(), endOfMonth(new Date(this.monthrange[1])).getTime()];
      this.getChartData();
    },
    pageResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    monthFill(data, startDate, endDate) {
      // 填补无数据的月
      const templateLabelMap = {};
      const eachMonths = eachMonthOfInterval({start: new Date(startDate), end: new Date(endDate)});
      eachMonths.forEach(date => {
        templateLabelMap[format(date, 'yyyy-MM')] = false;
      })
      data.forEach(item => {
        templateLabelMap[item.yearTime] = true;
      })
      for (let key in templateLabelMap) {
        if (!templateLabelMap[key]) {
          data.push({
            yearTime: key,
            serviceIndex: 0,
          })
        }
      }
      data = data.sort((a, b) => {
        const ay = a.yearTime.replace('-', '');
        const by = b.yearTime.replace('-', '');
        return ay - by;
      })
      return data;
    },
  }
}
</script>

<style lang="less" scoped>
.ml20 {
  margin-left: 20px;
}
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
}
.chart-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
}
.chart {
  margin-top: 20px;
  height: 400px;
}
</style>